import React from "react";

const SuppressionCleaningLog = () => {
  return (
    <div style={{ padding: 0, margin: 0 }}>
      <iframe
        src="https://suppressionagent.livauto.com/SuppressionCleaningLog.php"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        title="Suppression Cleaning Log"
      ></iframe>
    </div>
  );
};

export default SuppressionCleaningLog;
